import React, { useEffect, useRef } from "react";
import ButtonCustom from "../common/Button";
import { useTranslation } from "react-i18next";
import SignModal from "../common/general/signModal/signModal";

interface PatientExamProps {
  report: string,
  url: string,
  backClick?: () => void;
  singReport?: (base64Image: string) => void;
}

const PatientExamPDFViewAndSign: React.FC<PatientExamProps> = ({
  report,
  url,
  backClick,
  singReport,
}) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = React.useState<boolean>(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const urlIframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    if (url) {
      return;
    }
    const iframeDoc = iframeRef?.current?.contentDocument || iframeRef?.current?.contentWindow?.document;
    if (iframeDoc) {
      iframeDoc.open();
      iframeDoc.write(report);
      iframeDoc.close();
    }
  }, [report]);

  const onCloseHandler = () => {
    setShowModal(false);
  };

  const printHandler = () => {
    const iframe = url ? urlIframeRef.current : iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.print();
    }
  }

  const singHandler = () => {
    setShowModal(true);
  }
  const viewerUrl = `${url}`;
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <SignModal
        show={showModal}
        onClose={() => {
          onCloseHandler();
        }}
        onSignComplete={(signature: string) => {
          singReport && singReport(signature);
        }}
      />
      <div style={{ flex: "1", display: "flex", flexDirection: "column", minHeight: 0 }}>
        {url ? (
          <iframe
            className="patient-exam-iframe is-pdf-content"
            ref={urlIframeRef}
            key={viewerUrl}
            src={viewerUrl}
            title="Patient Exam PDF"
            onLoad={() => console.log('PDF iframe loaded:', url)}
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #ccc",
              flex: "1",
              minHeight: 0,
            }}
          />
        ) : (
          <iframe
            className="patient-exam-iframe is-html-content"
            ref={iframeRef}
            title="Patient Exam HTML"
            style={{
              width: "100%",
              height: "100%",
              border: "1px solid #ccc",
              flex: "1",
              minHeight: 0,
            }}
          />
        )}
      </div>
      <div className="actions d-flex justify-content-between align-items-center me-3 ms-3">
        <div className="align-self-start">
          <ButtonCustom
            type="button"
            onClick={backClick}
            className="btn-primary btn-lg"
            context={t("general.buttons.back")}
          />
        </div>
        <div className="d-flex justify-content-between align-items-center gap-2">
          {
            url  ? null : <ButtonCustom
              type="button"
              onClick={printHandler}
              className="btn-primary btn-lg"
              context={t("general.buttons.print")}
            />
          }

          <ButtonCustom
            type="button"
            onClick={singHandler}
            className="btn-primary btn-lg"
            context={t("general.buttons.sign")}
          />
        </div>

      </div>
    </div>
  );
};

export default PatientExamPDFViewAndSign;
